import * as React from 'react';
export const tagSvg = React.forwardRef(function tagSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.67 4.671a1.058 1.058 0 1 1-1.496-1.497 1.058 1.058 0 0 1 1.497 1.497Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.96.5v.002a2.01 2.01 0 0 1 1.469.587L11.11 5.77c.786.786.786 2.06 0 2.845L8.615 11.11a2.012 2.012 0 0 1-2.845 0L1.09 6.43A2.011 2.011 0 0 1 .5 4.96V1.806a.6.6 0 0 1 .176-.424L1.38.676l.092-.074A.6.6 0 0 1 1.806.5H4.96ZM1.7 2.054V4.98a.812.812 0 0 0 .238.6l4.682 4.682a.811.811 0 0 0 1.148 0l2.495-2.495a.811.811 0 0 0 0-1.148L5.58 1.937a.812.812 0 0 0-.6-.237H2.054l-.355.354Z',
    }),
  );
});
tagSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var tag = {
  category: 'icon',
  colorable: true,
  name: 'tag',
  svg: tagSvg,
};
